import React from 'react';
import { Link } from 'react-router-dom';
import { insolvencyProcessSteps } from '../data/sharedSteps';
import { PAGE_META } from '../data/pageMetaConfig';

const linkClass = 'text-amber-600 hover:text-amber-700 font-semibold underline';
const path = '/insolvency-lawyer';

export const pageMeta = {
  title: PAGE_META[path].title,
  metaDescription: PAGE_META[path].description,
  path,
  h1: 'עורך דין חדלות פירעון ושיקום כלכלי',
  faqSubtitle: 'מצאו תשובות לשאלות נפוצות בנוגע לחדלות פירעון ושיקום כלכלי.',
};

export const steps = insolvencyProcessSteps;

export const faq = [
  {
    question: 'מתי כדאי לשקול פתיחה של הליך חדלות פירעון?',
    answer:
      'כאשר סכום החובות גבוה משמעותית מהיכולת הכלכלית של החייב ואין סיכוי ממשי לפרוע אותם בפרק זמן סביר.',
  },
  {
    question: 'האם פתיחת ההליך עוצרת עיקולים והליכי הוצאה לפועל נגדי?',
    answer:
      'כן. עם הגשת הבקשה לקבלת צו פתיחת הליכים מוקפאים כל ההליכים הקיימים ונמנעים הליכים חדשים.',
  },
  {
    question: 'האם במהלך ההליך מותר לי להמשיך לעבוד ולהתפרנס?',
    answer: 'בהחלט. החוק מעודד השתכרות, והיא אף מהווה בסיס לקביעת התשלום החודשי.',
  },
  {
    question: 'איך נקבע גובה התשלום החודשי שאצטרך לשלם?',
    answer:
      'הממונה בוחן את כלל ההכנסות וההוצאות שלך, לפי נוסחה שמופיעה בנוהל רשמי, כדי לקבוע סכום חודשי הוגן.',
  },
  {
    question: 'האם ניתן להכניס להליך חובות מכל סוג?',
    answer:
      'מרבית סוגי החובות נכללים, אך יש חריגים: מזונות, קנסות פליליים וחובות שנוצרו במרמה – אינם נמחקים.',
  },
  {
    question: 'האם אפשר לצאת מהארץ בזמן שההליך מתנהל?',
    answer:
      'רק באישור מיוחד מהממונה או מבית המשפט, ולעיתים בכפוף להפקדת ערבות מתאימה.',
  },
];

export const sections = [
  {
    title: 'החובות סוגרים עליכם? יש דרך לצאת מזה',
    content: (
      <>
        <p>
          אם אתם מתמודדים עם חובות, עיקולים, תיקים בהוצאה לפועל או שיחות בלתי פוסקות מנושים – אתם לא
          לבד, וחשוב שתדעו שיש מה לעשות. הרבה אנשים מגיעים למצב שבו הם כבר לא מצליחים לעמוד
          בתשלומים. עוד הלוואה, עוד חיוב, עוד מכתב התראה, ופתאום מרגישים שהכול יוצא משליטה.
        </p>
        <p>
          הליך חדלות פירעון ושיקום כלכלי נועד בדיוק למצבים כאלה. המטרה שלו היא לאפשר לאדם שנקלע
          לחובות להסדיר את המצב בצורה מסודרת, לקבל הגנה משפטית, לעצור את הלחץ ובמקרים המתאימים –
          להגיע להפטר ולפתוח דף חדש.
        </p>
        <p>
          במשרד מיכלסון ושות׳ אנחנו מלווים חייבים בהליכי חדלות פירעון,{' '}
          <Link to="/debt-settlement-lawyer" className={linkClass}>
            הסדרי חוב
          </Link>
          , טיפול בעיקולים, עיכוב הליכים והתנהלות מול נושים, נאמנים, הממונה ובתי המשפט. המטרה שלנו
          היא פשוטה: לבדוק את המצב שלכם, להבין מה המסלול הנכון עבורכם, וללוות אתכם צעד-צעד עד
          לפתרון.
        </p>
      </>
    ),
  },
  {
    title: 'מהו הליך חדלות פירעון?',
    content: (
      <>
        <p>
          חדלות פירעון היא מצב שבו אדם או עסק לא מצליחים לשלם את החובות שלהם בזמן, או שהחובות גדולים
          יותר מהיכולת הכלכלית שלהם. במילים פשוטות: זה מצב שבו ההכנסות כבר לא מספיקות כדי לכסות את
          ההתחייבויות, והחובות ממשיכים להצטבר.
        </p>
        <p>
          הליך חדלות פירעון ושיקום כלכלי מאפשר להתמודד עם החובות בצורה מסודרת, תחת פיקוח של
          הגורמים המוסמכים. במקרים המתאימים, ההליך יכול להוביל בסופו של דבר לקבלת הפטר – כלומר
          מחיקת יתרת החובות שנכללים בהליך, בהתאם לדין. ההליך נועד לאפשר לחייב להשתקם כלכלית
          ולחזור למסלול חיים יציב יותר.
        </p>
      </>
    ),
  },
  {
    title: 'מהו הפטר ומה המשמעות של מחיקת חובות?',
    content: (
      <>
        <p>
          הפטר הוא אחד השלבים החשובים ביותר בהליך חדלות פירעון. במילים פשוטות, הפטר הוא מצב שבו
          החייב מקבל פטור מתשלום יתרת החובות שנכללים בהליך, בהתאם להוראות הדין ולאחר שעמד בתנאים
          שנקבעו לו. זה השלב שמאפשר לאדם לפתוח דף חדש מבחינה כלכלית.
        </p>
        <p>
          חשוב לדעת: לא כל חוב נמחק באופן אוטומטי. יש חובות שיכולים לקבל יחס שונה לפי החוק, ולכן
          חשוב לבדוק מראש אילו חובות יכולים להיכלל בהליך ומה המשמעות המעשית עבורכם. המטרה היא לא
          להבטיח הבטחות לא מבוססות, אלא לבדוק בצורה מקצועית מה ניתן לעשות ומה המסלול הנכון ביותר
          עבורכם.
        </p>
      </>
    ),
  },
  {
    title: 'מתי כדאי לפנות לעורך דין חדלות פירעון?',
    content: (
      <>
        <p>
          לא חייבים לחכות שהמצב יגיע לקצה. דווקא פנייה מוקדמת יכולה למנוע החמרה של המצב, לעצור
          הליכים בזמן, ולחסוך הרבה לחץ, טעויות והוצאות מיותרות. כדאי לפנות לייעוץ אם אתם מזהים אחד
          או יותר מהמצבים הבאים:
        </p>
        <ul>
          <li>אתם מתקשים לשלם הלוואות, אשראי או תשלומים חודשיים.</li>
          <li>יש לכם חובות לבנקים, חברות אשראי, ספקים, רשויות או אנשים פרטיים.</li>
          <li>נפתחו נגדכם תיקים בהוצאה לפועל.</li>
          <li>הוטל עיקול על חשבון הבנק, המשכורת או הרכב.</li>
          <li>אתם מקבלים מכתבים, שיחות או התראות מנושים.</li>
          <li>אתם שוקלים לקחת עוד הלוואה רק כדי לסגור חובות קודמים.</li>
          <li>אתם מרגישים שהמצב הכלכלי כבר לא בשליטה.</li>
        </ul>
        <p>
          בשלב הזה חשוב לעצור רגע, לא לפעול מתוך פחד, ולבדוק מה באמת נכון לעשות. לפעמים חדלות
          פירעון היא המסלול הנכון. לפעמים דווקא{' '}
          <Link to="/debt-settlement-lawyer" className={linkClass}>
            הסדר חובות
          </Link>
          , צו תשלומים או פתרון אחר יתאימו יותר. לכן חשוב לבדוק את התמונה המלאה לפני שמקבלים
          החלטה.
        </p>
      </>
    ),
  },
];
